// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CrawlerSessionStatusSchema = z.enum(['RUNNING','ABORTING','COMPLETED','FAILED','ABORTED'] as const);

export type CrawlerSessionStatusType = `${z.infer<typeof CrawlerSessionStatusSchema>}`

export default CrawlerSessionStatusSchema;
